import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { handleSubmit } from './reservation-redeem.service';
import { connect } from 'react-redux';
import { setIsTableReservationModalOpen } from '../../../../redux/modal/modal.actions';
import { fetchStore } from '../../../../redux/store/store.actions';
import { Col, Label, Row } from 'reactstrap';
import { fetchOnAuthenticated } from '../../../../redux/me/me.actions';
import { AvForm, AvGroup } from 'availity-reactstrap-validation';
import VerificationInput from 'react-verification-input';
import SaveSubmitButton from '../../form/buttons/SaveSubmitButton';

const ReservationReedemModal = ({
  isOpen,
  closeModal,
  targetReservationId: id,
}) => {
  const [accessCode, setAccessCode] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirmation = (event, errors, values) => {
    handleSubmit(
      event,
      errors,
      {},
      accessCode,
      false,
      setIsSubmitting,
      setAccessCode,
      closeModal,
      () => {},
      id,
    );
  };
  return (
    <Modal isOpen={isOpen} className="modal-dialog-centered">
      <AvForm onSubmit={handleConfirmation} disabled={isSubmitting}>
        <ModalBody>
          <AvGroup className="form-label-group text-center">
            <FormattedMessage id="tableReservationAccessCodeLabel"></FormattedMessage>
            <VerificationInput
              classNames={{
                container: 'container mt-2 verificationInput',
                character: 'character rounded',
                characterInactive: 'character--inactive',
                characterSelected: 'character--selected',
              }}
              length={4}
              validChars="0-9"
              inputProps={{ inputMode: 'numeric' }}
              placeholder=""
              onComplete={(value) => {
                setAccessCode(value);
              }}
            />
            <Label className="primary">
              <FormattedMessage id="tableReservationAccessCodeLabel" />
            </Label>
          </AvGroup>
        </ModalBody>
        <ModalFooter>
          <SaveSubmitButton
            className="w-100"
            data-testid="test-button"
            color="primary"
          >
            <FormattedMessage id="confirm" />
          </SaveSubmitButton>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

ReservationReedemModal.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  titleId: PropTypes.string,
  messageId: PropTypes.string,
  handleRemoval: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isTableReservationModalOpen: state.modals.isTableReservationModalOpen,
  me: state.me.me,
  store: state.store.store,
});

export default connect(mapStateToProps, {
  setIsTableReservationModalOpen,
  fetchStore,
  fetchOnAuthenticated,
})(ReservationReedemModal);
